const TradingStrategyTranslations = {
  'en-US': {
    trading: {
      pageTitle: 'Trading Strategies',
      hero: {
        title1: 'TRADING STRATEGIES LEASE',
        title2: 'SERVICE',
        desc:
          'Our Trading Strategies lease service is designed to provide fully automated, data-driven trading solutions. ' +
          'These strategies are meticulously developed using over 20 years of historical market data, ensuring reliability and consistency. ' +
          'Traders can access real-time market insights, leverage proven algorithmic strategies, and execute trades with precision. ' +
          'Whether you are a novice trader or an experienced professional, our platform empowers you to enhance your trading performance effortlessly.',
      },
      features: {
        tradingStrategy: {
          title: 'Fully Automated and Backtested Trading Strategies',
          desc: 'Trading Stratford delivers fully automated strategies, just like leading vendor solutions, powered by advanced quantitative models. Our strategies are thoroughly tested with over 20 years of historical market data, ensuring precision and optimal trade execution while minimizing risks.',
        },
        riskManagement: {
          title: 'Advanced Risk Management with Historical Testing',
          desc: 'Our trading strategies incorporate automated risk management features, tested rigorously with historical data. Just like top vendor strategies, we ensure a historical drawdown of less than 10% and diversify risk across multiple strategies to maintain stability and profitability.',
        },
        portfolio: {
          title: 'Transparent Performance Dashboard',
          desc: 'Our platform provides a comprehensive, transparent performance dashboard, similar to those offered by vendors. Traders can track key metrics, such as net profit, drawdown percentage, and trade success rates, while receiving real-time risk alerts to stay informed.',
        },
        cryptoTrading: {
          title: 'AI-Powered Cryptocurrency Trading Strategies',
          desc: 'Like vendor strategies, our cryptocurrency trading models are continuously tested with historical data. These AI-powered strategies are tailored to the dynamic crypto market, providing optimal investment opportunities based on past performance and trends.',
        },
      },
    },
  },
}

export default TradingStrategyTranslations
